import { logger } from "./logger";

const fetchRecaptchaToken = async action => {
  return new Promise(resolve => {
    try {
      window.grecaptcha.enterprise.ready(async () => {
        try {
          const token = await window.grecaptcha.enterprise.execute(
            window.ww.recaptchaSiteKey,
            { action }
          );
          resolve(token);
        } catch (error) {
          logger("Error in enterprise reCAPTCHA execution", {
            level: "error",
            customAttributes: { error }
          });
          resolve(null);
        }
      });
    } catch (error) {
      logger("Error in enterprise reCAPTCHA", {
        level: "error",
        customAttributes: { error }
      });
      resolve(null);
    }
  });
};

// Get RECAPTCHA token for enroll and register calls
export const getRecaptchaToken = async action => {
  if (!window.grecaptcha || !window.grecaptcha.enterprise) {
    logger("Error initializing enterprise reCAPTCHA", {
      level: "error"
    });
    return null;
  }

  const resolvedToken = await fetchRecaptchaToken(action);

  return resolvedToken;
};
